import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { LoginForm } from '../components/LoginForm'

export const Route = createFileRoute('/')({
	head: () => ({
		meta: [{ title: 'Jobilla' }],
	}),
	validateSearch: (search: Record<string, unknown>): { link?: 'resent' } =>
		search.link === 'resent' ? { link: 'resent' } : {},
	component: LoginScreen,
})

function LoginScreen() {
	const { t } = useTranslation('common')
	const { link } = Route.useSearch()
	const navigate = Route.useNavigate()

	return (
		<LoginForm
			heading={t('login.title')}
			linkResent={link === 'resent'}
			onDismissLinkResent={() => void navigate({ search: {}, replace: true })}
		/>
	)
}
